/**
 * Рассчитывает ожидаемое изменение размера отряда на основе отложенных действий найма
 * @param {Object} unit - Отряд
 * @param {Array} pendingRecruitmentActions - Массив отложенных действий найма
 * @returns {number} Ожидаемое изменение размера (положительное - увеличение)
 */
export const calcUnitUpdateBasedOnPendingRecruitment = (unit, pendingRecruitmentActions) => {
  if (!pendingRecruitmentActions || pendingRecruitmentActions.length === 0) {
    return 0;
  }

  // Находим все SIZE_RECRUITMENT действия для этого отряда
  const recruitmentActions = pendingRecruitmentActions.filter(
    action => action.unitId === unit.id && action.actionType === 'SIZE_RECRUITMENT'
  );

  // Суммируем общее увеличение размера
  return recruitmentActions.reduce((sum, action) => sum + (action.sizeAdded || 0), 0);
};